import React from "react";
import { useParams } from "react-router-dom";
import { StudentsCard } from "../../components/org/StudentsCard";

export const OrgStudents = () => {
  let { id } = useParams<any>();

  return (
    <div>
      <StudentsCard orgId={id} style={{   }} />
    </div>
  );
};
